import MapsApiBaseService from '../MapsApiBaseService';
import DrawEntityFactory from './DrawEntityFactory';

export default class DrawingAreaService extends MapsApiBaseService {
  #drawEntity = null;

  draw(area, drawingOptions, map) {
    if (this.googleMaps && map) {
      this.clear();
      this.#drawEntity = this.#getDrawEntity(area.mode, map);
      this.#drawEntity.draw(area.value, drawingOptions);
    }
  }

  clear() {
    this.#drawEntity?.clear();
    this.#drawEntity = null;
  }

  addListener(callback) {
    this.#drawEntity?.addListener(callback);
  }

  removeAllListeners() {
    this.clear();
  }

  #getDrawEntity(mode, map) {
    const DrawEntity = DrawEntityFactory.getDrawEntity(mode);

    return new DrawEntity(this.googleMaps, map);
  }
}
